<template>
    <div id="login">
        <div class="topBg" style="height:45%;width:100%;">
            <img src="../assets/img/T1009_1.png" style="width:100%;height:100%;" alt="">
            <div class="ab PT_title">
                <p style="font-size:60px;padding-bottom:12px;"><i style="font-weight:400;">Welcome</i></p>
                <div class="pt_title">
                    <p style="font-weight:600;background-image: linear-gradient(to left top, #fff, #a7afd7,#fff);color: transparent;-webkit-background-clip: text;"><i>跳米用户服务平台</i></p>
                    <p style="font-size:20px;padding-top:5px;"><i>Tiaomi User Service Platform</i></p>
                </div>
            </div>
            <p class="ab" style="top:6px;right:12px;z-index:4;color:#eeeeee;">潮平两岸阔，风正一帆悬</p>
        </div>
        <div class="loginStyle">
            <el-form :model="loginForms" ref="loginForms" :rules="rules">
                <el-form-item prop="userName" :rules="filter_rules({required:true,type:'userName',message:'请输入用户名称',min:5,max:45})">
                    <el-input prefix-icon="el-icon-s-custom" v-model.trim="loginForms.userName" maxlength="45" placeholder="用户名" clearable></el-input>
                </el-form-item>
                <el-form-item prop="passWord">
                    <el-input prefix-icon="el-icon-more" show-password v-model.trim="loginForms.passWord"  maxlength="16" placeholder="密 码" clearable></el-input>
                </el-form-item>
                <el-form-item prop="imgCode" style="position:relative;">
                    <el-input prefix-icon="el-icon-discount" v-model.trim="loginForms.imgCode" placeholder="验证码" :maxlength='4' clearable style="width:266px;"></el-input>
                    <span class="yzmimg" >
                        <img :src='codeSrc' @click="getCode()" draggable="false" style="margin-top:4px;margin-left:10px;" alt="">
                    </span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="logins" round @click.native.prevent="codeLogin('loginForms')" @keyup.enter.native="codeLogin('loginForms')" style="font-size:16px;width:100%;margin-top:12px;">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    var axios = require('axios')
    import {mapActions} from "vuex";
    export default {
        name: 'login',
        data() {
            return {
                codeSrc: "",
                rules: {
                    imgCode: [
                        {required: true, message: '请输入验证码', trigger: ["blur", "change"]},
                        { min: 4, message: " ",trigger: ["blur", "change"]}
                    ],
                    passWord:[
                        {required: true, message: '请输入密码', trigger: ["blur", "change"]}
                    ],
                },
                loginForms: {
                    userName: '',
                    passWord: '',
                    imgCode: '',
                    vtoken:''
                },
            };
        },
        methods: {
            ...mapActions([
                'saveInfo', 'saveLogUrl'
            ]),
            //登录
            codeLogin(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loginSend();
                    } else {
                        return false;
                    }
                });
            },
            //获取验证码
            getCode() {
                this.loginForms.imgCode = '';
                axios.defaults.withCredentials = true;
                axios({
                    method: 'get',
                    url: this.API.url + 'getVtoken',
                })
                .then(resd => {
                    if(resd.data.code == 200){
                        this.loginForms.vtoken = resd.data.message;
                        this.IsCode(resd.data.message);
                    }else{
                        this.$message.error(resd.data.message);
                    }
                })
            },
            //判断验证码是否正确
            IsCode(vtoken) {
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'imgCode?vtoken=' + vtoken,
                    transformRequest: [function (data) {
                        let ret = ''
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                        }
                        return ret
                    }],
                    responseType: "arraybuffer",
                    headers:{'Content-Type':'application/x-www-form-urlencoded'}
                })
                .then(res => {
                    this.codeSrc = 'data:image/jpeg;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                })
            },
            //发送登录请求
            loginSend() {
                let obj = {};
                Object.assign(obj, this.loginForms);
                obj.passWord = this.$md5(obj.passWord);
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'login',
                    data: obj,
                }).then(resd => {
                    if (resd.data.code == 200) {
                        document.cookie = "tibiot-personal-card=Bearer " + resd.data.data.val + ";path=/;"
                        this.saveLogUrl({logUrl: '/home'});
                        this.$router.push('/home'); //跳转页面
                    } else {
                        this.$message.error(resd.data.message);
                        this.getCode(); //重新获取验证码
                    }
                })
            },
        },
        created() {
            //清除token
            if (this.$common.getCookie('tibiot-personal-card')) {
                document.cookie = 'tibiot-personal-card=' + this.$common.getCookie('tibiot-personal-card') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';
                window.localStorage.removeItem("vuex-along");//清除vue-along
            }
            this.getCode(); //重新获取验证码
            // 注册回车事件
            var _self = this;
            document.onkeydown = function (e) {
                let keys = 0;
                if (window.event == undefined) {
                    keys = e.keyCode;
                } else {
                    keys = window.event.keyCode;
                }
                if (keys == 13) {
                    _self.codeLogin('loginForms');
                }
            }
        }
    };
</script>
<style scoped>
    #login{
        width: 100%;
        height: 100%;
        min-width: 700px;
        background:#fff;
    }
    .topBg{
        position: relative;
    }
    .topBg::before{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background:linear-gradient(rgb(52 75 149 / 76%));
        z-index: 1;
    }
    .loginStyle {
        width: 400px;
        margin:40px auto 0px;
    }
    .PT_title{
        width: 100%;
        bottom:50px;
        z-index: 4;
        color:#dbdff2;
        text-align: center;
    }
    .pt_title{
        width: 380px;
        margin:0px auto;
        border:1px solid #91a0e0;
        border-radius: 5px;
        padding:14px 0px 14px;
        font-size:26px;
    }
    .logins{
        display: inline-block;
        width: 329px;
        padding: 10px 0px !important;
    }
    .yzmimg{
        background:#fff;
        display:block;
        position:absolute;
        right:0px;
        top:0px;
        width:120px;
        height:38px;
        border:1px solid #dcdfe6;
        border-radius:20px;
        font-size: 0px;
        overflow: hidden;
    }
</style>
<style>
#login .el-input__prefix{
    left:10px;
}
#login .el-input--prefix .el-input__inner{
    padding-left: 40px;
}
#login .el-input__inner{
    border-radius: 20px;
}
#login .el-form-item__error{
    left:13px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue